import React from "react";
import styled from "styled-components";
import moment from "moment";
import EnablePricingFooter from "./Pricing/EnablePricingFooter";
import { Container } from "./Grid";
import DealerLogin from "./Pricing/DealerLogin";

const StyledFooter = styled.footer`
  padding: 2rem 0;
  border-top: 1px solid #dedede;
  text-align: left;
  color: #fff;
  background: ${({ theme }) => theme.secondary};
  font-size: 0.8rem;
`;

const Footer = () => (
  <>
    <StyledFooter>
      <Container>
        <div>
          © {moment().format("YYYY")}. BioFit Engineered Products. All rights reserved.{" "}
          <DealerLogin />
        </div>
      </Container>
    </StyledFooter>
    <EnablePricingFooter />
  </>
);

export default Footer;
